import { render, staticRenderFns } from "./MasterPayerList.vue?vue&type=template&id=2606368b&scoped=true&"
import script from "./MasterPayerList.vue?vue&type=script&lang=js&"
export * from "./MasterPayerList.vue?vue&type=script&lang=js&"
import style0 from "./MasterPayerList.vue?vue&type=style&index=0&id=2606368b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2606368b",
  null
  
)

export default component.exports